import { FC, ReactElement } from 'react'
import styled from 'styled-components'

export const Definition = () => {
  return (
    <StyledDefinition>
      <Venn>
        <VennContent>
          <div className='a1'>
            <div className='wrapper'>
              <span>Künstliche Intelligenz</span>
              <div>Hauptsächlich regelbasierte Systeme</div>
            </div>
            <div className='a2'>
              <div className='wrapper'>
                <span>Maschinelles Lernen</span>
                <div>Lernfähige Algorithmen</div>
              </div>
              <div className='a3'>
                <div className='wrapper'>
                  <span>Deep Learning</span>
                  <div>Mehrschichtige lernfähige Algorithmen</div>
                </div>
              </div>
            </div>
          </div>
        </VennContent>
      </Venn>
      <Time>
        <div className='a1'>1950er</div>
        <div className='a2'>1980er</div>
        <div>2010er</div>
      </Time>
    </StyledDefinition>
  )
}

const Time = styled.div`
  text-align: left;
  margin-bottom: 30px;
  font-family: var(--font-sans-serif);
  font-size: 12px;
  border-top: 2px solid var(--text-color);
  margin-top: 15px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: -11px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 20px solid var(--text-color);
    border-width: 10px;
  }
  div {
    display: inline-block;
    &.a1 {
      width: 18%;
    }
    &.a2 {
      width: 30%;
    }
  }
`
const StyledDefinition = styled.div`
  text-align: right;
  margin-bottom: 60px;
`
const Venn = styled.div`
  position: relative;
  text-align: right;
`
const VennContent = styled.div`
  font-family: var(--font-sans-serif);
  text-align: right;

  div {
    color: #fff;
    font-size: 15px;
    line-height: 0;
    letter-spacing: 0.5px;
    span {
      display: inline-block;
      width: 100%;
      font-weight: 900;
      line-height: 1.3em;
      font-size: 18px;
      margin-top: 15px;
      margin-bottom: 5px;
    }
    div {
      line-height: 1.2em;

      display: inline-block;
    }
    .wrapper {
      width: calc(100% - 20px);
      padding: 15px;
      text-align: left;
      margin-bottom: 15px;
    }
  }

  div.a1 {
    background-color: var(--petrol-main);

    width: 100%;
  }
  div.a2 {
    background-color: var(--purple-main);
    width: 80%;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  div.a3 {
    background-color: var(--brandblue-main);
    width: 60%;    margin-right: 10px;
    margin-bottom: 10px;
  }
`
